@if (_loading) {
    <div class="border-box-full" [style.height.px]="250">
        <app-dashboard-page-loader></app-dashboard-page-loader>
    </div>
} @else {
<div class="flex-column pad-L">
    <div class="font-MM fw-700">{{ 'page.agent.workstations.versions.widgetName' | translate}}</div>

    @if (mainChartVersions.length > 0) {
        <div class="flex-align-center w-100 gap-S pad-top-L">
            @for (item of mainChartVersions; track item.version) {
                <div class="main-graph-part flex-align-end" [style.background-color]="item.color" [style.width]="item.width + '%'">{{item.version}}</div>
            }
        </div>
    } @else {
        <div class="flex-align-center w-100 gap-S pad-top-L">
            <div class="main-graph-part flex-align-end w-100 grey bg-rounded" style="background-color: #F2F2F7;">{{ 'page.agent.workstations.versions.noData' | translate}}</div>
        </div>
    }

    <div class="divider"></div>

    <div class="w-100">
        @for (item of barChartVersions; track item.version) {
            <div class="w-100 pad-top-L">
                <div class="flex-space-between pad-bottom-XS">
                    <div>Version {{item.version}} <span class="grey" *ngIf="isLatest(item.version)">({{'page.agent.workstations.versions.latest' | translate}})</span></div>
                    <div class="flex-align-center gap-XS">
                        <div class="grey" *ngIf="item.count">({{item.count}})</div>
                        <div class="fw-600">{{item.width | number:'1.0-0'}}%</div>
                    </div>
                </div>

                <div class="bar-chart-part-background"></div>
                <div class="bar-chart-part" [style.background-color]="item.color" [style.width]="item.width + '%'"></div>
            </div>
        }
    </div>
</div>
}
